// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1WnO7","rightAdornment":"Header_rightAdornment__Iik2E"};